import { Subtitle } from '@/components/commons/typography/Subtitle'
import { useIsOwnProfile } from 'containers/profile/hooks/useProfile'
import { Text } from '@/components/commons/typography/Text'

interface ProfileTagsSectionProps {
  tags: string[]
  emptyText: string
  title: string
}

export const ProfileTagsSection = ({
  tags,
  emptyText,
  title,
}: ProfileTagsSectionProps) => {
  const isOwnProfile = useIsOwnProfile()
  const isEmpty = tags.length === 0

  return (
    <div>
      <Subtitle
        sizeClass="text-14 text-15--tablet"
        weightClass="font-bold font-medium--tablet"
      >
        {title}
      </Subtitle>

      <div className="flex gap-8 wrap mt-12">
        {tags.map((type, index) => (
          <div key={type + index} className="py-4 px-8 bg-tertiary rounded-6">
            <Text sizeClass="text-13 text-14--tablet" colorClass="text-info">
              {type}
            </Text>
          </div>
        ))}
        {isEmpty && isOwnProfile && (
          <Text sizeClass="text-14 text-16--tablet" colorClass="text-tertirary">
            {emptyText}
          </Text>
        )}
        {isEmpty && !isOwnProfile && (
          <Text sizeClass="text-14 text-16--tablet" colorClass="text-tertirary">
            -
          </Text>
        )}
      </div>
    </div>
  )
}
